import React, { Component, Fragment } from "react";
import axios from "axios";
import * as PropTypes from "prop-types";
import { Col, Form, Input, message, Modal, Tabs, Row, Select, Spin } from "antd";
import { debounce } from "lodash";

import moment from "moment";

import { API_ERRO_TYPE_CANCEL } from "./../../config/general";

import { annualLeaveService, departmentsService, companiesService } from "./../../redux/services";

import {
	UIDrawerForm,
	UIFormSection,
	UISteps,
} from "./../../components";

import PeriodsTable from "./tables/periods"
import ModalRecalculate from './ModalRecalculate';

import {
	STEPS,
	STEP_FIELDS,
	AnnualLeaveAbsencesFields,
	AnnualLeaveExtrasFields,
	AnnualLeaveInfoBanner,
	AnnualLeaveStatusField,
} from "./create";

const formId = `form-drawer-${Math.floor(Math.random() * 10001)}`;

const EDIT_STEP_FIELDS = {
	...STEP_FIELDS,
	ties: ["companies", "departments"],
};

class Edit extends Component {
	static propTypes = {
		visible: PropTypes.bool.isRequired,
		onComplete: PropTypes.func.isRequired,
		onClose: PropTypes.func.isRequired,
	};

	constructor(props) {
		super(props);

		this.state = {
			isLoading: true,
			isSending: false,
			uuid: 0,
			periods: [],
			hasEmployees: false,
			vinculos_outros_bancos: {},
			activeKey: "general",

			data: [],

			companies: [],
			companiesIsLoading: false,
			selectedCompanies: [],
			departments: [],
			disabledSelectAllDepartments: false,
			blockedAllDepartments: false,
			departmentsIsLoading: false,
			selectedDepartments: [],

			recalcularModalVisible: false,
			formToCompare: {},
		};

		this._axiosCancelCompaniesToken = null;
		this._axiosCancelDepartmentsToken = null;
	}

	onOpen = (uuid) => {
		this.setState({
			isLoading: true,
			uuid: uuid,
			activeKey: "general",
		});

		annualLeaveService.show({ uuid })
			.then((response) => {
				let item = response.data.data;
				let { vinculo_funcionario_banco_horas } = item || {};
				let employees = vinculo_funcionario_banco_horas;

				if (employees.length > 0) {
					this.setState({
						hasEmployees: true
					})
				} else {
					this.setState({
						hasEmployees: false
					})
				}

				const selectedCompanies = item?.companies ? item.companies.map((company) => company.id) : [];

				this.setState({
					isLoading: false,
					periods: item.banco_horas_vigencia ?? [],
					companies: item?.companies ?? [],
					selectedCompanies,
					departments: item?.departments ?? [],
					vinculos_outros_bancos: response.data.vinculos_outros_bancos ?? [],
				}, () => {
					// Fill form
					this.descricao && this.descricao.focus();

					this.fillForm(item);
				});
			})
			.catch((data) => {
				Modal.error({
					title: "Ocorreu um erro!",
					content: String(data),
					onOk: () => {
						// Force close
						return this.onClose();
					}
				});
			});
	};

	validVigencyToLink = (othersVigencies) => {
		const currentVigencies = this.periodsTable?.state?.periods?.map((period) => ({ vigencia_inicio: moment(period.data_inicial).format('YYYY-MM-DD'), vigencia_final: moment(period.data_final).format('YYYY-MM-DD') }));

		if (currentVigencies.every(item => item.vigencia_inicio === 'Data inválida')) return true;
		const result = currentVigencies.some(
			current => othersVigencies.some(other => {
				const currentStart = moment(current.vigencia_inicio).startOf('day');
				const currentEnd = moment(current.vigencia_final).endOf('day');
				const otherStart = moment(other.vigencia_inicio).startOf('day');
				const otherEnd = moment(other.vigencia_final).endOf('day');

				return currentStart.isBefore(otherEnd) && otherStart.isBefore(currentEnd);
			})
		);

		return result;
	}

	filterAllowedCompaniesDepartaments = (changedSelect) => {
		const { departments, vinculos_outros_bancos, selectedCompanies } = this.state;
		const { vinculoEmpresaDepartamento, vinculoEmpresaTodosDep, vinculoGeral } = vinculos_outros_bancos;

		let filteredDepartments = departments;
		const paramsToUpdate = {};

		const isSelectedAllCompanies = selectedCompanies?.includes('todos') || !selectedCompanies.length;
		const selectedCompanyHasAllDepartments = vinculoEmpresaTodosDep?.some(item => {
			if (isSelectedAllCompanies || selectedCompanies.includes(item.empresa_id)) {
				return this.validVigencyToLink(item.vigencias);
			}

			return false;
		});
		const vinculoGeralValidationConflict = vinculoGeral?.some(
			item => this.validVigencyToLink(item.banco_horas_vigencia)
		);

		if (
			vinculoGeralValidationConflict ||
			selectedCompanyHasAllDepartments
		) {
			this.setState({
				departments: [],
				disabledSelectAllDepartments: true,
				blockedAllDepartments: true,
			}, () => {
				this.form.setFieldValue("departments", []);
			});

			return;
		} else {
			paramsToUpdate.blockedAllDepartments = false;
			paramsToUpdate.disabledSelectAllDepartments = false;
		}

		vinculoEmpresaDepartamento?.forEach((item) => {
			if (
				(
					item.empresa_id === null ||
					selectedCompanies.includes(item.empresa_id) ||
					isSelectedAllCompanies
				) &&
				this.validVigencyToLink(item.vigencias)
			) {
				filteredDepartments = filteredDepartments.filter(
					(department) => !item.departamentos_ids.includes(department.id)
				);

				paramsToUpdate.disabledSelectAllDepartments = true;

				if (changedSelect) this.form.setFieldValue("departments", []);
			} else {
				paramsToUpdate.disabledSelectAllDepartments = false;
			}
		});

		this.setState({
			departments: filteredDepartments,
			...paramsToUpdate,
		});
	}

	fetchCompanies = () => {
		if (this._axiosCancelCompaniesToken) {
			this._axiosCancelCompaniesToken.cancel("Only one request allowed at a time.");
		}

		this._axiosCancelCompaniesToken = axios.CancelToken.source();

		this.setState({
			companiesIsLoading: true,
		});

		companiesService.getAutocomplete({
			orderBy: "nome:asc",
			cancelToken: this._axiosCancelCompaniesToken.token,
		})
			.then((response) => {
				this.setState({
					companies: response.data.data,
					companiesIsLoading: false,
				});
			})
			.catch((data) => {
				if (data.error_type === API_ERRO_TYPE_CANCEL) return null;

				this.setState({
					companiesIsLoading: false,
				});

				Modal.error({
					title: "Ocorreu um erro!",
					content: String(data),
				});
			});
	};

	fetchDepartments = (value) => {
		if (this._axiosCancelDepartmentsToken) {
			this._axiosCancelDepartmentsToken.cancel("Only one request allowed at a time.");
		}

		this._axiosCancelDepartmentsToken = axios.CancelToken.source();

		// if (value !== undefined && !value.trim().length) {
			// this.setState({
				// departmentsIsLoading: false,
				// departments: [],
			// });

			// return false;
		// }

		this.setState({
			departmentsIsLoading: true,
		});

		let params = {
			...(value ? { search: value } : {}),
			orderBy: "nome:asc",
			cancelToken: this._axiosCancelDepartmentsToken.token,
			empresas_ids: this.form.getFieldValue("companies").includes("todos") ? [] : this.form.getFieldValue("companies"),
		}

		departmentsService.getAutocomplete({
			...params
		})
			.then((response) => {
				this.setState({
					departmentsIsLoading: false,
					departments: response.data.data,
				}, () => {
					this.filterAllowedCompaniesDepartaments();
				});
			})
			.catch((data) => {
				if (data.error_type === API_ERRO_TYPE_CANCEL) return null;

				this.setState({
					departmentsIsLoading: false,
				});

				Modal.error({
					title: "Ocorreu um erro!",
					content: String(data),
				});
			});
	};

	fetchDepartmentsSearch = debounce(this.fetchDepartments, 500);

	onCompanyChange = (value) => {
		let selectedCompanies = value;
		if (value.length > 1 && value.includes("todos")) {
			selectedCompanies = value.filter((item) => item !== "todos")
			this.form.setFieldValue("companies", selectedCompanies);
		}

		this.setState({
			departments: [],
			departmentsIsLoading: false,
			selectedCompanies,
		}, () => {
			this.filterAllowedCompaniesDepartaments(true);
		});

		this.form.setFieldValue("departments", ["todos"]);
	};

	onCompanySelect = (value) => {
		if (value === "todos") {
			this.form.setFieldValue("companies", ["todos"]);

			this.setState({
				selectedCompanies: ["todos"],
			},  () => {
				this.filterAllowedCompaniesDepartaments(true);
			});
		}
	};

	onDepartmentChange = (value) => {
		if (value.length > 1 && value.includes("todos")) {
			this.form.setFieldValue("departments", value.filter((item) => item !== "todos"));
		}
	};

	onDepartmentSelect = (value) => {
		if (value === "todos") {
			this.form.setFieldValue("departments", ["todos"]);
		}
	};

	fillForm = (data) => {
		let faixas = [];

		if (data.multiplicar_percentual_domingo == 1) {
			faixas.push("domingo")
		}
		if (data.multiplicar_percentual_folga == 1) {
			faixas.push("folga")
		}
		if (data.multiplicar_percentual_uteis == 1) {
			faixas.push("uteis")
		}
		if (data.multiplicar_percentual_feriado == 1) {
			faixas.push("feriado")
		}
		if (data.multiplicar_percentual_sabado == 1) {
			faixas.push("sabado")
		}

		const formValues = {
			descricao: data.descricao,
			periods: this.state.periods,
			is_active: data.is_active,
			tipo_controle_extra: data.tipo_controle_extra,
			combinar_faixa_diurna_noturna: data.combinar_faixa_diurna_noturna,
			controle_faltas: data.controle_faltas,
			controle_atraso: data.controle_atraso,
			nao_multiplicar_pelo_percentual: data.nao_multiplicar_pelo_percentual,
			extra_domingo: data.extra_domingo,
			extra_feriado: data.extra_feriado,
			extra_folga: data.extra_folga,
			extra_sabado: data.extra_sabado,
			extra_uteis: data.extra_uteis,
			companies: (data.companies && data.companies?.length > 0) ? data.companies.map((item) => item.id) : ["todos"],
			departments: (data.departments && data.departments?.length > 0) ? data.departments.map((item) => item.id) : ["todos"],
			limite_maximo_de_faltas: data.limite_maximo_de_faltas?.substr(0, 5),
			limite_maximo_de_extras: data.limite_maximo_de_extras?.substr(0, 5),
			faixas_de_horario: faixas,
			multiplicar_percentual_domingo: false,
			multiplicar_percentual_folga: false,
			multiplicar_percentual_uteis: false,
			multiplicar_percentual_feriado: false,
			multiplicar_percentual_sabado: false,
		};

		this.form.setFieldsValue(formValues);

		this.setState({
			formToCompare: formValues,
		})
	};

	resetFields = () => {
		this.form.resetFields();
	};

	onClose = () => {
		// Reset fields
		this.resetFields();

		// Callback
		this.props.onClose();
	};

	checkIfNeedToRecalculate = (dataVigencia) => {
    const fieldHasNoNeedToCallRecalculate = ['descricao'];
    const { formToCompare } = this.state;

    if (!this.form || typeof this.form.getFieldValue !== 'function') {
			return false;
    }

    const periodsChanged = !!(dataVigencia && this.getChangedVigenciesPeriod(dataVigencia));

    const fieldsModified = Object.keys(formToCompare).reduce((changes, field) => {
			if (field !== 'periods' && !fieldHasNoNeedToCallRecalculate.includes(field)) {
				const fieldValue = this.form.getFieldValue(field);
				const compareValue = formToCompare[field];
				const hasChanged = typeof fieldValue === 'object' && fieldValue !== null ?
					JSON.stringify(fieldValue) !== JSON.stringify(compareValue) :
					fieldValue !== compareValue;
				if (hasChanged) {
					changes[field] = hasChanged;
				}
			}
			return changes;
    }, {});

    const needToRecalculate = periodsChanged || Object.keys(fieldsModified).some(fieldName => {
			return !fieldHasNoNeedToCallRecalculate.includes(fieldName);
    });

    return needToRecalculate;
	};

	onFinish = (values) => {
		this.setState({
			isSending: true,
		});

		const { uuid } = this.state;

		const data = {
			controle_atraso: values?.controle_atraso,
			controle_faltas: values?.controle_faltas,
			descricao: values?.descricao,
			extra_domingo: values?.extra_domingo,
			extra_feriado: values?.extra_feriado,
			extra_folga: values?.extra_folga,
			extra_sabado: values?.extra_sabado,
			extra_uteis: values?.extra_uteis,
			is_active: values?.is_active,
			limite_maximo_de_extras: values?.limite_maximo_de_extras,
			limite_maximo_de_faltas: values?.limite_maximo_de_faltas,
			nao_multiplicar_pelo_percentual: values?.nao_multiplicar_pelo_percentual,
			tipo_controle_extra: values?.tipo_controle_extra,
			combinar_faixa_diurna_noturna: values?.combinar_faixa_diurna_noturna,
			companies: values?.companies,
			departments: values?.departments,
			uuid: values?.uuid,
			faixas_de_horario: values?.faixas_de_horario,
			multiplicar_percentual_domingo: values?.multiplicar_percentual_domingo,
			multiplicar_percentual_folga: values?.multiplicar_percentual_folga,
			multiplicar_percentual_uteis: values?.multiplicar_percentual_uteis,
			multiplicar_percentual_feriado: values?.multiplicar_percentual_feriado,
			multiplicar_percentual_sabado: values?.multiplicar_percentual_sabado,
		};

		if (data.faixas_de_horario) {
			data.faixas_de_horario.forEach((faixa) => {
				data[`multiplicar_percentual_${faixa}`] = true;
			})
		}

		// uuid
		data.uuid = uuid;

		if (!(data.companies instanceof Array)) {
			data.companies = [data.companies];
		}

		if (!(data.departments instanceof Array)) {
			data.departments = [data.departments];
		}

		if (data.companies.includes("todos")) {
			data.companies = null;
			data.todas_empresas = true;
		}

		if (data.departments.includes("todos")) {
			data.todas_departamentos = true;
			data.departments = null;
		}

		data.vigencia = this.periodsTable?.state?.periods.map((period) => ({ id: period.id, acao: period.action ?? "criar", vigencia_inicio: moment(period.data_inicial).format('YYYY-MM-DD'), vigencia_final: moment(period.data_final).format('YYYY-MM-DD') }));

		this.periodsTable?.state?.deletedsOriginalPeriods?.length > 0 && this.periodsTable?.state?.deletedsOriginalPeriods?.forEach((period) =>
			data.vigencia.push(
				({ id: period.id, acao: period.action, vigencia_inicio: moment(period.data_inicial).format('YYYY-MM-DD'), vigencia_final: moment(period.data_final).format('YYYY-MM-DD') })
			));

		data.acao = 'editar';

		this.setState(({
			data: data,
		}));

		// Call recalculate modal
		const { hasEmployees } = this.state;

		if (hasEmployees && this.checkIfNeedToRecalculate(data.vigencia)) {
			this.recalculateOpen(data);
			return;
		}
		
		annualLeaveService.edit(data)
			.then((response) => {
				this.setState({
					isSending: false,
				});
				this.props.onComplete();

			})
			.catch((data) => {
				this.setState({
					isSending: false,
				});

				Modal.error({
					title: "Ocorreu um erro!",
					content: String(data),
				});
			});
	};

	onFinishFailed = ({ errorFields }) => {
		const field = errorFields[0]?.name[0];
		const step = STEPS.find(({ key }) => this.getStepFields(key).includes(field));

		if (step && step.key !== this.state.activeKey) {
			this.setActiveKey(step.key, () => this.form.scrollToField(field));
		}
	};

	getStepFields = (key) => {
		if (key === "periods") {
			return (this.periodsTable?.state?.periods ?? []).flatMap(({ id }) => [`${id}_data_incial`, `${id}_data_final`]);
		}

		return EDIT_STEP_FIELDS[key] ?? [];
	};

	setActiveKey = (activeKey, callback) => {
		this.setState({ activeKey }, callback);

		if (activeKey === "ties") {
			this.filterAllowedCompaniesDepartaments(true);
		}
	};

	recalculateOpen = ({ uuid, vigencia }) => {
		this.setState({
			recalcularModalVisible: true,
			isLoading: false,
			isSending: false,
		});

		// Without vigency changes the period is left for the user to choose
		const period = this.getChangedVigenciesPeriod(vigencia ?? []);

		// On open screen
		this.recalculateScreen.onOpen(uuid, period);
	};

	// Covers the days that started or stopped being part of the hours bank
	getChangedVigenciesPeriod = (vigencies) => {
		const originals = this.state.formToCompare.periods ?? [];
		const today = moment().startOf("day");
		const lastEnd = moment.min(moment.max([...originals, ...vigencies].map(({ vigencia_final }) => moment(vigencia_final).startOf("day"))), today);
		const ranges = [];

		vigencies.forEach(({ id, acao, vigencia_inicio, vigencia_final }) => {
			const original = originals.find((period) => period.id === id);

			if (!original || acao === "criar") {
				ranges.push([moment(vigencia_inicio).startOf("day"), lastEnd]);
				return;
			}

			const originalStart = moment(original.vigencia_inicio).startOf("day");
			const originalEnd = moment(original.vigencia_final).startOf("day");

			if (acao === "deletar") {
				ranges.push([originalStart, moment.min(originalEnd, today)]);
				return;
			}

			const start = moment(vigencia_inicio).startOf("day");
			const end = moment(vigencia_final).startOf("day");

			if (!start.isSame(originalStart)) {
				ranges.push([moment.min(start, originalStart), lastEnd]);
			}

			if (!end.isSame(originalEnd)) {
				ranges.push([moment.min(end, originalEnd, today), moment.min(moment.max(end, originalEnd), today)]);
			}
		});

		if (!ranges.length) return null;

		return {
			data_inicial: moment.min([...ranges.map(([start]) => start), today]),
			data_final: moment.max(ranges.map(([, end]) => end)),
		};
	};

	recalculateOnClose = () => {
		this.setState({ recalcularModalVisible: false });

		// Success message
		message.success("Registro atualizado com sucesso.");
	};

	recalculateOnComplete = () => {
		this.setState({ recalcularModalVisible: false }, () => {

			// Success message
			message.success("Cálculo realizado com sucesso.");
			// Callback
			this.props.onComplete();
		});
	};

	onCancelRecalculate = () => {
		this.setState({ recalcularModalVisible: false });
		// Callback
		this.props.onComplete();
	}

	render() {
		const { visible } = this.props;

		const {
			isLoading,
			isSending,
			periods,
			companies,
			companiesIsLoading,
			departments,
			departmentsIsLoading,
			recalcularModalVisible,
			disabledSelectAllDepartments,
			blockedAllDepartments,
			activeKey,
		} = this.state;

		return (
			<Fragment>
				<UIDrawerForm
					visible={visible}
					width={1100}
					onClose={this.onClose}
					isLoading={isLoading}
					isSending={isSending}
					formId={formId}
					icon={<i className="fal fa-hourglass-half" />}
					title="Editar banco de horas"
					subtitle="Atualize as regras do banco de horas e a quem ele se aplica."
					footer={
						<UISteps
							steps={STEPS}
							current={activeKey}
							onChange={(key) => this.setActiveKey(key)}
							onCancel={this.onClose}
						/>
					}>
					<Form
						ref={el => this.form = el}
						id={formId}
						layout="vertical"
						scrollToFirstError
						onFinish={this.onFinish}
						onFinishFailed={this.onFinishFailed}>
						<Tabs activeKey={activeKey} onChange={(key) => this.setActiveKey(key)}>
							<Tabs.TabPane forceRender tab={<span className="tab-icon-label">{STEPS[0].icon} {STEPS[0].label}</span>} key="general">
								<UIFormSection
									icon={<i className="fal fa-clipboard-list" />}
									title="Informações gerais"
									description="Identificação e situação do banco de horas.">
									<Row gutter={16}>
										<Col xs={24} md={12}>
											<Form.Item name="descricao" label="Descrição" hasFeedback rules={[{ required: true, message: "Campo obrigatório." }]}>
												<Input ref={el => this.descricao = el} placeholder="Digite a descrição do banco de horas" />
											</Form.Item>
										</Col>
										<Col xs={24} md={12}>
											<AnnualLeaveStatusField />
										</Col>
									</Row>
								</UIFormSection>
								<AnnualLeaveInfoBanner description="Com funcionários vinculados, ao salvar alterações além da descrição você pode recalcular os cartões de ponto." />
							</Tabs.TabPane>
							<Tabs.TabPane forceRender tab={<span className="tab-icon-label">{STEPS[1].icon} {STEPS[1].label}</span>} key="periods">
								<UIFormSection
									icon={<i className="fal fa-calendar-alt" />}
									title="Períodos"
									description="Datas de início e fim em que o banco de horas fica valendo.">
									<PeriodsTable values={periods} ref={el => this.periodsTable = el} />
								</UIFormSection>
							</Tabs.TabPane>
							<Tabs.TabPane forceRender tab={<span className="tab-icon-label">{STEPS[2].icon} {STEPS[2].label}</span>} key="extras">
								<AnnualLeaveExtrasFields />
							</Tabs.TabPane>
							<Tabs.TabPane forceRender tab={<span className="tab-icon-label">{STEPS[3].icon} {STEPS[3].label}</span>} key="absences">
								<AnnualLeaveAbsencesFields />
							</Tabs.TabPane>
							<Tabs.TabPane forceRender tab={<span className="tab-icon-label">{STEPS[4].icon} {STEPS[4].label}</span>} key="ties">
								<UIFormSection
									icon={<i className="fal fa-building" />}
									title="Empresas e departamentos"
									description="Define a quais empresas e departamentos o banco de horas se aplica.">
									<Row gutter={16}>
										<Col xs={24} md={12}>
											<Form.Item name="companies" label="Empresa" rules={[{ required: true, message: "Campo obrigatório." }]}>
												<Select
													mode="multiple"
													optionFilterProp="children"
													filterOption={(input, option) => (typeof option.children === 'string' ? option.children : option.children.props.children).toLowerCase().indexOf(input.toLowerCase()) >= 0}
													allowClear
													placeholder="Selecione a(s) empresa(s)"
													notFoundContent={companiesIsLoading ? <Spin indicator={<i className="fad fa-spinner-third fa-spin" />} /> : null}
													onDropdownVisibleChange={(open) => open && this.fetchCompanies()}
													onSearch={this.fetchCompanies}
													onChange={this.onCompanyChange}
													onSelect={this.onCompanySelect}
													showSearch>
													<Select.Option value="todos">Todas</Select.Option>
													{companies.map((item, index) => (
														<Select.Option key={index} value={item.id}>
															{item.nome}
														</Select.Option>
													))}
												</Select>
											</Form.Item>
										</Col>
										<Col xs={24} md={12}>
											<Form.Item
												name="departments"
												label="Departamento"
												rules={[{ required: true, message: "Campo obrigatório." }]}
												extra={blockedAllDepartments ? "Uma ou mais empresas selecionadas já possuem um banco de horas vinculado a todos os departamentos. Selecione outra empresa ou ajuste os vínculos existentes para continuar." : null}>
												<Select
													mode="multiple"
													optionFilterProp="children"
													filterOption={(input, option) => (typeof option.children === 'string' ? option.children : option.children.props.children).toLowerCase().indexOf(input.toLowerCase()) >= 0}
													allowClear
													placeholder="Selecione o(s) departamento(s)"
													notFoundContent={departmentsIsLoading ? <Spin indicator={<i className="fad fa-spinner-third fa-spin" />} /> : null}
													onDropdownVisibleChange={(open) => open && this.fetchDepartments()}
													onSearch={this.fetchDepartmentsSearch}
													onChange={this.onDepartmentChange}
													onSelect={this.onDepartmentSelect}
													disabled={blockedAllDepartments}
													showSearch>
													{!disabledSelectAllDepartments && <Select.Option value="todos">Todos</Select.Option>}
													{departments.map((item, index) => (
														<Select.Option key={index} value={item.id}>{item.nome}</Select.Option>
													))}
												</Select>
											</Form.Item>
										</Col>
									</Row>
								</UIFormSection>
							</Tabs.TabPane>
						</Tabs>
					</Form>
				</UIDrawerForm>
				<ModalRecalculate
					ref={el => this.recalculateScreen = el}
					visible={recalcularModalVisible}
					onComplete={this.recalculateOnComplete}
					onClose={this.recalculateOnClose}
					onCancel={this.onCancelRecalculate}
					data={this.state.data}
				/>
			</Fragment>
		)
	}
}

export default Edit;
